/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-vars */
import React, { useState,useEffect,useCallback ,useMemo} from 'react';
import { useTranslation } from 'react-i18next';
import { AgGridReact } from 'ag-grid-react';
import { NGODatePicker,EditModal,LoaderPop,DeleteConf} from '../../../common';
import deleteIcon from '../../../assets/icons/deleteRole.svg';
import { IoCashOutline, IoCardOutline,IoTrendingUpOutline,IoTrendingDownOutline } from "react-icons/io5";
import { PiMoneyFill } from "react-icons/pi";
import { LiaMoneyBillWaveAltSolid } from "react-icons/lia";
import { IoMdArrowDropdown,IoMdArrowDropup,IoIosTrendingUp,IoIosTrendingDown } from "react-icons/io";
import { FaMoneyBillWave,FaCreditCard } from "react-icons/fa";
import LoadingGIF from '../../../assets/loadingIn.gif';
import editIcon from "../../../assets/edit.svg";
import { IoMdCard } from "react-icons/io";
import { FaRegCreditCard } from "react-icons/fa6";
import moment from 'moment';
import usePermissions from '../../../utils/userPermissions';
import { APIEndpoint} from "../../../utils/axios";
import closeIcon from "../../../images/icons/Icon2.png";
import CustomSelect from '../../../common/CustomSelect';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {formatDateByTimezone,getCultureFromLs,calculateTextWidth,sanitizeNumberInput} from '../../../utils/commonFunctions';
import CurrencyListing from '../currencyList';

  const filterData = {
    action: 4,
    collection: '',
    filterOperation: 'or',
    filters: [{ employeeType: 'crew' }],
    limit: 50,
    page: 1,
    searchParam: ''
  };
const RemarkFormFields = [
  { label: 'Comment', attribute: 'comment', type: 'textarea', required: true },
]
export const CrewDepositsPage = () => {
  const { ready } = useTranslation();
  const firstLoad = React.useRef(true);
  const prevDateRef = React.useRef(null);
  const skipCalcRef = React.useRef(false);
  const gridRef =  React.useRef(null);
   const prevCardDeclaredRef = React.useRef(0);
   const prevCrewDeclaredRef = React.useRef(0);
  const lastTotalRef = React.useRef(0);
  const skipNextEditFetchRef =  React.useRef(false);
  const [lastCurrencyFetchDate, setLastCurrencyFetchDate] = useState(null);
  const [state,setState] = useState({operatingDate:formatDateByTimezone(new Date(), false),warningPop:false,userSelected:null,isReloadTableData:false,cashDrawerList:[],cashDrawerListMaster:[],addComment:false,baseCurrency:getCultureFromLs()?.currency?.code,comment:''});
  const [crewMembers, setCrewMembers] = useState([]);
  const [exchangeRates, setExchangeRates] = useState([]);
  const [crewMembersMaster, setCrewMembersMaster] = useState([]);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [sectorsList,setSectorsList] = useState([]);
  const [catererLoading,setCatererLoading] = useState({oprnDate:false,caterer:false,passenger:false,editLoading:false});
 const [mode,setMode] = useState({edit:false,editId:null,editEnable:false});
  const [passengersList,setPassengersList] = useState({});
  const [passengerErrors, setPassengerErrors] = useState([]);
  const [listingItems,setListingItems]=useState({count:0,items:[]});
  const [sectorSelectOptionsList,setSectorsSelectOptionsList]=useState([]);
    const [cardSalesDeclaredTotal, setCardSalesDeclaredTotal] = useState(0);
  const [crewSales,setCrewSales]=useState([]);
  const [sectors,setSectors] = useState([]);
  const [cateringGroupList, setCateringGroupsList] = useState([]);
  const [cateringGroupSelected, setCateringGroupSelected] = useState(null);
  const [sectorSelected, setSectorSelected] = useState(null);
  const [cashDrawerSelected, setCashDrawerSelected] = useState(null);
  const [loadingUser, setLoadingUsers] = useState(false);
    const [cateringGroupWidth, setCateringGroupWidth] = useState({catgroupWidth:'10rem',crewMemberWidth:'15rem'});
  const [cashSales, setCashSales] = useState({ crewDeposits: {}, passengerDeposit: 0});
  const [passengers, setPassengers] = useState([{ sector: null, passenger: null, amount: '' }]);
  const [cardSalesDeclared, setCardSalesDeclared] = useState('');
  const [currencyRows,setCurrencyRows] = useState([]);
  const [message,setMessage] = useState({text:""});
  const [ loadingCashDeposits,setLoadingCashDeposits] = useState(false);
  const [showRefundSection, setShowRefundSection] = useState(false);
  const [totalSalesFromPOS,setTotalSalesFromPOS] = useState(0);
  const [totalDepositByCrew, setTotalDepositByCrew] = useState({catGroup:0,catGroupSum:0});
const [refundInitialized, setRefundInitialized] = useState(false);
  const [cardSalesFromPOS,setCardSalesFromPOS]=useState(0);
  const [totalSalesFromCrew,setTotalSalesFromCrew] = useState(0);
  const [cardsalesFromCrew,setCardSalesFromCrew]=useState(0);
  const [pendingPopupOpen, setPendingPopupOpen] = useState(false);
  const [depositTotalCount, setDepositTotalCount] = useState(null);
  const [pendingDepositCrewsList, setPendingDepositCrewsList] = useState([]);
  const [activeSessionId, setActiveSessionId] = useState(null);
const baseCurr = state?.baseCurrency || getCultureFromLs()?.currency?.code;
const [refundtoCrew, setRefundToCrew] = useState({currencyCode: { key: 1, label: baseCurr, value: baseCurr },amount: ""});

  const allCurrenciesRef = React.useRef([]);
  const rotationLoadingRef = React.useRef(false);
  const sectorsListRef = React.useRef([]);
  const userChangedDrawer = React.useRef(false);
  const roundFactorRef = React.useRef(null);


  const MIN_CATGROUP_WIDTH = 270;
  const SAFE_PADDING = 40;


const hasRefunds = useMemo(() => {
  return Array.isArray(passengers) &&
  passengers.some(p => parseFloat(p.amount) >= 0);
}, [passengers]);

  const { hasPermission: viewCashDeposits  } = usePermissions('view', 'orn:CashRegister:CreateCashDeposit');
  const { hasPermission: createDeposit } = usePermissions('create', 'orn:CashRegister:CreateCashDeposit');
  const { hasPermission: editDeposit } = usePermissions('edit', 'orn:CashRegister:CreateCashDeposit');

  const { hasPermission: deleteRefunds } = usePermissions('delete', 'cashregister.refund');
  const { hasPermission: viewRefunds } = usePermissions('view', 'cashregister.refund');
  const { hasPermission: createRefund } = usePermissions('create', 'cashregister.refund');
  const { hasPermission: editRefund } = usePermissions('edit', 'cashregister.refund');

function getDynamicHeader(title) {
  return `${title} (${state?.baseCurrency || ""})`;
}
const resolveAmount = (obj) => {
  if (!obj) return 0;

  const converted = Number(obj.totalConvertedAmount);
  if (!isNaN(converted) && converted > 0) {
    return converted;
  }

  const raw = Number(obj.totalAmount);
  return !isNaN(raw) ? raw : 0;
};


const getSafeCurrencyCode = () => {
  return (
    getCultureFromLs()?.currency?.code ||
    state?.baseCurrency || "" 
  );
};

function exitViewOnly() {
  setMode(prev => ({ 
    ...prev, 
    edit: false, 
    editId: null, 
    editEnable: false 
  }));
   setRefundToCrew(prev => ({
    ...prev,
    amount: ""
  }));
   setState((_)=>({..._,userSelected:null}));

  prevDateRef.current = null;
  setPendingDepositCrewsList([]);
  setSelectedRowIndex(null);
  setCashDrawerSelected(null);
  setTotalSalesFromPOS(0);
  setCardSalesFromPOS(0);
      setCrewSales([]);
    setSectorSelected(null);
    setPassengersList({});
    setSectorsList([]);
    setCardSalesDeclaredTotal(0);
    setSectorsSelectOptionsList([]);
    setPassengers([{ sector: null, passenger: null, amount: '' }]);
    setCrewMembers([]);
    setCardSalesDeclared("");
    setTotalSalesFromCrew(0);
    setCardSalesFromCrew(0);
    setCashSales({crewDeposits:{},passengerDeposit:0 });
}


  const SectorsCellRenderer = (data) => {
const {value,headerName}=data;
      return (
        <><div className='flexRow justifyContentSpaceBetween'  style={{width:'100%',maxWidth:'225px',overflow:'auto'}}>
        <div className={`sector-container ${headerName} justifyContentFlexStart alignItemsCenter`} style={{marginRight:'1.5rem',maxWidth:headerName!=='Sectors'?'80px':'auto'}}>
          <span className="uplift-user" style={{width:'200px'}}>{value??""}</span>
        </div>
      </div>
      </>)
  };

const roundByFactor = useCallback((amount) => {
  if (amount === null || amount === undefined || amount === "") return "";

  const num = Number(amount);
  if (isNaN(num)) return amount;

  const factor = Number(roundFactorRef.current);

  if (!factor || factor <= 0) {
    return Number(num);
  }

  return Math.round(num / factor) * factor;
}, []);

  const round2 = (n) => {
  if (n === null || n === undefined || n === "") return "";
  const num = Number(n);
  if (isNaN(num)) return n;
  return num.toFixed(2); 
};

function capturePendingDeposits() {
  const pending = crewSales.filter(sale =>!listingItems?.items?.some(dep => dep?.crew?.employeeId === sale?.crew?.employeeId));
  setPendingDepositCrewsList(pending);
  setPendingPopupOpen(prevState => !prevState);
}


const getCrewTransactions = useCallback((id) => {
  if (!crewSales || crewSales.length === 0) return 0;

  const userFound = crewSales.find(crw => crw.crew?.employeeId === id);
  if (!userFound) return 0;

  return resolveAmount(userFound.cash);
}, [crewSales]);


  const showActions = !mode.edit || mode.editEnable;

  const columns = useMemo(() => 
 {
   const baseCol=[
   {field: 'code', headerName: 'Crew Name',valueGetter: (params) => {
      const crewDetails = params?.data?.crew;
      if (crewDetails) {
        return `${crewDetails?.employeeCode} - ${crewDetails?.employeeName||""}`;
      }
      return null;
    },  cellStyle: {
      whiteSpace: 'normal',  
      overflow: 'visible',   
      wordWrap: 'break-word', 
      lineHeight: '2',
      padding:'5px 0px 0px 12px',   
      maxWidth: '100%',    
      height: 'auto',        
    },resizable: true, minWidth: 230,width:250,suppressSizeToFit:true, flex: 1,},
    { field: 'createdAt', headerName: 'Deposit Date',valueGetter: (params) => {
         const creationDate = params?.data?.createdAt;
  if (creationDate) {
    return moment(creationDate).tz(getCultureFromLs()?.timezone.name).format('DD-MM-YYYY hh:mm A');
  }
  return null;
        },resizable:true,suppressSizeToFit:true, minWidth: 100,flex:1},
        { field: 'createdBy.employeeName', headerName: 'Cashier Agent',cellRendererFramework: (params) => (
          <SectorsCellRenderer
            {...params}
            headerName={params.colDef.headerName}
          />
        ),suppressSizeToFit:true,resizable:true, minWidth: 110,flex:1, },

{
  field: 'totalCashSales',
  headerName: getDynamicHeader('Total Sales Cash'),
  cellStyle: (params) => {
    if (params.value < 0) return { color: '#ff443dff', fontWeight: "700" };
    if (params.value > 0) return { color: '#ffffff' };
    return null;
  },
  valueGetter: (params) => {
    const crewId = params.data?.crew?.employeeId || null;
    const amount = getCrewTransactions(crewId);

    return round2(roundByFactor(amount));  
  },
  resizable: true,
  suppressSizeToFit: true,
  minWidth: 110,
  flex: 1,
},

{
  field: 'totalDeposited',
  headerName: getDynamicHeader('Cash Deposited'),
  cellStyle: (params) => {
    if (params.value < 0) return { color: '#ff443dff', fontWeight: "700" };
    if (params.value > 0) return { color: '#ffffff' };
    return null;
  },
  valueGetter: (params) => {
    const val = params.data?.totalDeposited ?? 0;
    return round2(roundByFactor(val)); 
  },
  suppressSizeToFit: true,
  resizable: true,
  minWidth: 110,
  flex: 1,
},
{
  field: 'difference',
  headerName: getDynamicHeader('Difference'),
  cellStyle: (params) => {
    if (params.value < 0) return { color: '#b16b61' };
    if (params.value > 0) return { color: '#76b683' };
    return null;
  },
  valueGetter: (params) => {
    const deposited = params.data?.totalDeposited ?? 0;

    const crewId = params.data?.crew?.employeeId || null;
    const sales = getCrewTransactions(crewId);
    const crewRefund = parseFloat(params?.data?.totalCrewRefund) || 0;
    const passengerRefund = parseFloat(params?.data?.totalRefund) || 0;

    return round2(roundByFactor(deposited - sales - (crewRefund + passengerRefund)));
  },
  resizable: true,
  suppressSizeToFit: true,
  minWidth: 110,
  flex: 1,
}];
  if (showActions && editDeposit) {
    baseCol.push({
      headerName: "Actions",
      width: 80,
      maxWidth: 100,
      resizable: true,
      flex: 1,
      cellRenderer: ActionCell,
      pinned: "right"
    });
  }
  return baseCol;
}
, [state.baseCurrency, editDeposit, getCrewTransactions, showActions, activeSessionId]);

  function ActionCell(props) {
    if (!props?.data) return null;
    return (
        <div className="flexRow justifyContentSpaceBetween" onClick={(e) => e.stopPropagation()}>
         {activeSessionId === props.data?.sessionId && (
        <div className="flexRow justifyContentFlexStart">
          <button
            title="Edit Deposits"
            className="margRight30"
            onClick={(e) => {
              e.stopPropagation();
              setMode(prev => ({ ...prev, editEnable: true }));
            }}
          >
            <img width={20} src={editIcon} alt="Edit" />
          </button>
        </div>
      )}
      </div>

    );
  }


  const showToast = useCallback(()=>{
        toast.dismiss();

        if (message.text) {
          toast.success(message.text, {
            position: toast.POSITION.TOP_CENTER,
            hideProgressBar: true,
            pauseOnHover: true,
            draggable: false,
            autoClose: 2000,
            style: {
              backgroundColor: '#4cae4c',
              color: '#fff',
              borderRadius: '8px',
              fontSize: '1rem',
            }
          });
        } else if (message.error) {
          toast.error(message.error, {
            position: toast.POSITION.TOP_CENTER,
            hideProgressBar: true,
            pauseOnHover: true,
            draggable: false,
            autoClose: 2000,
            style: {
              backgroundColor: '#d9534f',
              color: '#fff',
              borderRadius: '8px',
              fontSize: '1rem',
              width:'30rem'
            }
          });
        } else {

        }
      },[message])

const crewStats = useMemo(() => {
  if (!crewMembers.length && state?.userSelected) {
    setState((_) => ({ ..._, userSelected: null }));
  }
  const totalCrew = crewMembers?.length || 0;
  const totalDeposited = listingItems?.count || 0;
  const crewWithSales = crewSales.length;
  const pending = Math.max(crewWithSales - totalDeposited, 0);

  return {
    totalCrew,
    crewWithSales,
    totalDeposited,
    pending
  };
}, [crewMembers?.length, listingItems?.items, crewSales.length]);

useEffect(() => {
  if (!baseCurr) return;

  setRefundToCrew(prev => {
    if (prev?.currencyCode?.value) return prev;

    return {
      ...prev,
      currencyCode: {
        key: 1,
        label: baseCurr,
        value: baseCurr
      }
    };
  });
}, [baseCurr]);

        useEffect(() => {
          if (!message.text && !message.error) return;
          showToast();
          const timer = setTimeout(() => {
            setMessage({ text: "" });
          }, 2500);
      
          return () => clearTimeout(timer);
        }, [message.text, message.error, showToast]);

useEffect(() => {
  if (firstLoad.current) {
    firstLoad.current = false;
    Promise.allSettled([getEmployeesAll(),fetchCashDrawersList()]);

  }
}, []);



useEffect(() => {
  if (!cashDrawerSelected) return;

  setDepositTotalCount(null);
  setListingItems({ count: 0, items: [] });
}, [cashDrawerSelected?.value]);

useEffect(() => {
  if (
    !cashDrawerSelected?.value ||
    !cateringGroupSelected ||
    !state.operatingDate
  ) return;
  fetchCashDeposits();
}, [
  cashDrawerSelected?.value,
  cateringGroupSelected?.value,
  state.operatingDate
]);

useEffect(() => {
  if (cateringGroupSelected) {
   const w = calculateTextWidth(cateringGroupSelected.label);
   const nextWidthPx = Math.max(w + SAFE_PADDING, MIN_CATGROUP_WIDTH);

     const newWidth = `${nextWidthPx}px`;
   setCateringGroupWidth(prev => {
 if (prev.catgroupWidth === newWidth) return prev;
 return {...prev,catgroupWidth: newWidth}
   }
  
  );
   return;
  }
  lastTotalRef.current = 0;
  skipCalcRef.current = true;

  setCashSales({
    crewDeposits: {},
    passengerDeposit: 0
  });

  setTotalDepositByCrew({
    catGroup: 0,
    catGroupSum: 0
  });

  setRefundToCrew(prev => ({
    ...prev,
    amount: ""
  }));

  setRefundInitialized(false);

  setTotalSalesFromCrew(0);
  setCardSalesFromCrew(0);
}, [cateringGroupSelected, state.operatingDate]);



const resetDepositContext = () => {

  skipCalcRef.current = true;
  lastTotalRef.current = 0;

  setCashSales({
    crewDeposits: {},
    passengerDeposit: 0
  });

  setTotalDepositByCrew({
    catGroup: 0,
    catGroupSum: 0
  });

  setRefundToCrew(prev => ({
    ...prev,
    amount: ""
  }));

  setPassengers([
    { sector: null, passenger: null, amount: "" }
  ]);
  setPassengerErrors([]);
  setListingItems({ count: 0, items: [] });
  setDepositTotalCount(null);
};


useEffect(() => {
  if (state.userSelected) {
  const w = calculateTextWidth(state.userSelected.label);
const nextWidthPx = Math.max(w + SAFE_PADDING, MIN_CATGROUP_WIDTH);
     const newWidth = `${nextWidthPx}px`;
  setCateringGroupWidth(prev => {
    if (prev.crewMemberWidth === newWidth) return prev;
    return { ...prev, crewMemberWidth: newWidth };
  });

  } 
}, [state.userSelected]);


useEffect(() => {
  sectorsListRef.current = sectorsList;
}, [sectorsList]);

useEffect(() => {
  const userId = state.userSelected?.key;

  if (!userId) {
    setCardSalesFromCrew(0);
    setTotalSalesFromCrew(0);
    return;
  }

  if (crewSales.length === 0) return;

  const userFound = crewSales.find((crw) => crw.crew?.employeeId === userId);

  if (!userFound) {
    setCardSalesFromCrew(0);
    setTotalSalesFromCrew(0);
    return;
  }


const nextCard = resolveAmount(userFound.card);
 const nextCash = resolveAmount(userFound.cash);

  setCardSalesFromCrew((prev) => (prev !== nextCard ? nextCard : prev));
  setTotalSalesFromCrew((prev) => (prev !== nextCash ? nextCash : prev));
}, [crewSales, state.userSelected]);


useEffect(() => {

  if (mode.edit && catererLoading.editLoading) return;

  const hasSelections =
    cateringGroupSelected || state.operatingDate || cashDrawerSelected;

  if (hasSelections) {
    if (!mode.edit && cateringGroupSelected) {
      fetchSectors(cateringGroupSelected.value, false);
      fetchRotationSalesSummary(cateringGroupSelected.value);
    }

    if (!mode.edit && cateringGroupSelected) {
      fetchCashDeposits();
    }

   if (
  mode.edit &&
  !catererLoading.editLoading &&
  cateringGroupSelected &&
  !skipNextEditFetchRef.current
) {
  fetchCashDeposits();
}
  }

  if (!cateringGroupSelected && !mode.edit) {
    setPendingDepositCrewsList([]);
    setPendingPopupOpen(false);
    setPassengerErrors([]);
    setCrewSales([]);
    setSectorSelected(null);
    setPassengersList({});
    setSectorsList([]);
    setCardSalesDeclaredTotal(0);
    setSectorsSelectOptionsList([]);
    setPassengers([{ sector: null, passenger: null, amount: '' }]);
    setCrewMembers([]);
    setCashDrawerSelected(null);
    setCardSalesDeclared("");
    setTotalSalesFromPOS(0);
    setCardSalesFromPOS(0);
    setTotalSalesFromCrew(0);
    setCardSalesFromCrew(0);
  }

  if (!mode.edit && state.cashDrawerListMaster?.length === 1) {
    setCashDrawerSelected(state.cashDrawerListMaster[0]);
  }

  if (!mode.edit && !mode.editId) {
    setCashSales({
      crewDeposits: {},
      passengerDeposit: 0
    });
  }

skipNextEditFetchRef.current = false;
  setListingItems({ count: 0, items: [] });

}, [
  cateringGroupSelected,
  cashDrawerSelected,
  state.cashDrawerListMaster,
  state.operatingDate,
  mode.edit,
  catererLoading.editLoading
]);

useEffect(() => {
  if (mode.edit) return; 
  if (!state.operatingDate) return;
setSelectedRowIndex(null);
const selDate= moment(formatDateByTimezone(state.operatingDate ? new Date(state.operatingDate) : new Date())).format("YYYY-MM-DD")
if(lastCurrencyFetchDate !== selDate){
   setCateringGroupSelected(null);
}

    prevDateRef.current = state.operatingDate;
    fetchCurrencyEntity();
    fetchDepositSectors().catch((e) =>
      console.error("Error fetching deposit sectors:", e)
    );

}, [state.operatingDate,state.userSelected,mode.edit,lastCurrencyFetchDate]);


useEffect(() => {

  if (cateringGroupSelected) {
const getSum = (key) => listingItems.items.reduce((acc, item) => acc + item[key], 0);
const sum = listingItems.items.length ? getSum('totalDeposited') : 0;
const sumCardSales = listingItems.items.length ? getSum('totalDeclaredCardSales') : 0;
const sumRefunds = listingItems.items.length ? getSum('totalRefund') : 0;

const formattedSum = parseFloat(sumCardSales) || 0;
prevCardDeclaredRef.current = formattedSum;
setCardSalesDeclaredTotal(formattedSum);
setTotalDepositByCrew((prev) => ({
  ...prev,
  catGroupSum: parseFloat(sum) - parseFloat(sumRefunds),
}));



  } else {
    setTotalDepositByCrew({ catGroup: 0, catGroupSum: 0 });
  }
}, [listingItems.count,cateringGroupSelected,mode.edit]);


useEffect(() => {
  if (!Array.isArray(state.cashDrawerListMaster) || !state.cashDrawerListMaster.length || mode.edit) return;

  if (!sectorSelectOptionsList?.length) {
    setState(prev => ({ ...prev, cashDrawerList: state.cashDrawerListMaster }));
    return;
  }

  const hasMatch = state.cashDrawerListMaster.some(cdM =>
    sectorSelectOptionsList.some(sct => sct.label.split("-")[2] === cdM.locationCode)
  );

  const filteredCashDrawer = hasMatch ? state.cashDrawerListMaster.filter(cdM => sectorSelectOptionsList.some(sct => sct.label.split("-")[2] === cdM.locationCode)) : state.cashDrawerListMaster; 

  setState(prev => {
    const isSame =
      filteredCashDrawer.length === prev.cashDrawerList.length &&
      filteredCashDrawer.every((cd, i) => cd.value === prev.cashDrawerList[i]?.value);
    return isSame ? prev : { ...prev, cashDrawerList: filteredCashDrawer };
  });
 // eslint-disable-next-line react-hooks/exhaustive-deps
}, [sectorSelectOptionsList, state.cashDrawerListMaster, mode.edit]);


useEffect(() => {
  if (!cashDrawerSelected || !sectorSelectOptionsList?.length) return;

const lastSector = sectorSelectOptionsList[sectorSelectOptionsList.length - 1] ?? null;
if (sectorSelected?.value !== lastSector?.value) setSectorSelected(lastSector);
 // eslint-disable-next-line react-hooks/exhaustive-deps
}, [cashDrawerSelected, sectorSelectOptionsList]);


async function fetchEmployees(page=1, perPage=1,searchKey=''){
  filterData.page = page;
  filterData.limit = perPage;
  filterData.searchParam = searchKey;
  try {
    const res=await APIEndpoint.post('employees/process',filterData);
    return res;
  } catch (error) {
    console.error("Failed to fetch employees:", error);
  }
}


const getEmployeesAll = useCallback(async () => {
  setLoadingUsers(true);
  try {
    const initialRes = await fetchEmployees(1, 1);
    const total = initialRes?.count || 0;

    if (total > 0) {
      const fullRes = await fetchEmployees(1, total);

      if (Array.isArray(fullRes?.items) && fullRes.items.length) {
        const formattedEmployees = fullRes.items.map((item, index) => ({
          key: item.employeeId,
          label: `${item.employeeCode} - ${item.name}`,
          value: item.employeeCode,
        }));
        setCrewMembersMaster(formattedEmployees);
      }
    }
  } catch (error) {
    console.error("Failed to fetch employees:", error);
  } finally {
    setLoadingUsers(false);
  }
}, []);


useEffect(() => {

    setDepositTotalCount(null);
    
  
}, [cateringGroupSelected, cashDrawerSelected, state.operatingDate]);

const gridHeight = useMemo(() => {
  return Math.max(
    (listingItems.items?.length ?? 1) * 42 + 42,
    107
  );
}, [listingItems.items?.length]);


useEffect(() => {
  if (skipCalcRef.current) {
    skipCalcRef.current = false;
    return; 
  }

  if (!cashSales) return;
  if (mode.edit && catererLoading.editLoading) return;
  if (!cateringGroupSelected) return;

  let total = Object.values(cashSales.crewDeposits || {}).reduce(
    (sum, val) => sum + (parseFloat(val) || 0),
    0
  );

  total = Number(total) || 0;

  const delta = total - lastTotalRef.current;

  setTotalDepositByCrew(prev => ({
    ...prev,
    catGroup: prev.catGroup + delta,
    catGroupSum: prev.catGroupSum + delta,
  }));
    lastTotalRef.current = total;
  
}, [
  cashSales,
  mode.edit,
  cateringGroupSelected,
  catererLoading.editLoading,

]);

useEffect(() => {
  if (cashDrawerSelected?.value && allCurrenciesRef.current.length) {
    fetchCashDrawersListMain(cashDrawerSelected.value);
  }
}, [allCurrenciesRef.current.length]);


useEffect(() => {
  if (cashDrawerSelected?.value) {
    fetchCashDrawersListMain(cashDrawerSelected.value);
  } else {
    setActiveSessionId(null);
  }
}, [cashDrawerSelected]);


const fetchCashDrawersListMain = async (cashDrawerId) => {
  if (!cashDrawerId) return;
  if (!allCurrenciesRef.current.length) return;

  try {
    const res = await APIEndpoint.get(
      `cashRegister/cashDrawers/${cashDrawerId}`
    );

    const cashDrawer = res?.cashDrawer;
    if (!cashDrawer) return;

    setActiveSessionId(cashDrawer?.lock?.sessionId ?? cashDrawer?.latestSessionId ?? null);
    const enabledCodes = new Set(
      cashDrawer.enabledCurrencies?.map(c => c.currencyCode)
    );
  const homeCurrency = getSafeCurrencyCode();
    const filteredCurrencies = allCurrenciesRef.current
      .filter(c => enabledCodes.has(c.code))
      .map(c => c.code);

  setCurrencyRows(Array.from(new Set([homeCurrency, ...filteredCurrencies])));

  } catch (error) {
    console.error("Error fetching cash drawer details:", error);
    setCurrencyRows([]);
  }
};



const fetchSectors = async (id,edit=false) => {
  if (!id || !(sectors instanceof Map) || !sectors.has(id) || !state.cashDrawerListMaster.length) return [];

  const sectorArraySelected = sectors.get(id);

  if (!sectorArraySelected?.length) return [];

  const list = sectorArraySelected.map((item, index) => {
     const dte =   moment(item?.std).tz(getCultureFromLs()?.timezone.name).format('YYYY-MM-DD')
   return { key: index + 1,
    label: `${item.flightNumber}-${item.origin}-${item.destination}`,
    value: item.id,
    flightArr:dte
  }
  });

  if (state?.cashDrawerListMaster?.length) {
    const lastDestination = sectorArraySelected[sectorArraySelected.length - 1]?.destination;
    const matchingDrawer = state.cashDrawerListMaster.find(cDr => cDr.locationCode === lastDestination);

   if (!userChangedDrawer.current && !mode.edit && !edit && matchingDrawer?.value !== cashDrawerSelected?.value) {
  setCashDrawerSelected(matchingDrawer || null);
 }

    const uniqueCrew = [
      ...new Map(
        sectorArraySelected.flatMap(cr => cr.crew).map(obj => [obj.employeeCode, obj])
      ).values(),
    ];
    if (uniqueCrew.length && crewMembersMaster?.length) {
      const crewCodes = new Set(uniqueCrew.map(c => c.employeeCode));
      const filteredCrew = crewMembersMaster.filter(crw => crewCodes.has(crw.value));
    let maxWidth = 0;
    filteredCrew.forEach(item => {
      const w = calculateTextWidth(item.label);
      if (w > maxWidth) maxWidth = w;
    });
    setCateringGroupWidth(prev => { 
      const nextWidthPx = Math.max(maxWidth + SAFE_PADDING, MIN_CATGROUP_WIDTH);
     const nextWidth = `${nextWidthPx}px`;
  if (prev.catgroupWidth === nextWidth) return prev; 
  return { ...prev, catgroupWidth: nextWidth };
    });
          setCrewMembers(filteredCrew);
    }

    setSectorsSelectOptionsList(list);
    setSectorsList(sectorArraySelected);
    return list;
  }

  return list;
};
useEffect(() => {
  userChangedDrawer.current = false;
}, [cateringGroupSelected]);

const fetchCurrencyEntity = useCallback(async () => {
  try {
    const currentDate = moment(
      formatDateByTimezone(
        state.operatingDate ? new Date(state.operatingDate) : new Date()
      )
    ).format("YYYY-MM-DD");


    if (lastCurrencyFetchDate === currentDate) return;

    const bodyCurrency = { date: currentDate };
  const homeCurrency = getCultureFromLs()?.currency?.code;

    const [resIbr, resCurrencies] = await Promise.all([
      APIEndpoint.post("operations/ibrExchange/rates", bodyCurrency),
      APIEndpoint.get("/currencies"),
    ]);

    if (resIbr?.rates?.items?.length) {
      setExchangeRates(
        new Map(
          resIbr.rates.items.map(rt => [
            `${rt.fromIsoCode}_${rt.toIsoCode}`,
            rt.rate
          ])
        )
      );
    }

 if (Array.isArray(resCurrencies.items) && resCurrencies.items?.length) {
  const activeCurrencyObjects = resCurrencies.items.filter(c => c.isActive);
  const roundFactor = resCurrencies.items.find(c => c.code === homeCurrency)?.roundingFactor;


  allCurrenciesRef.current = activeCurrencyObjects;
  roundFactorRef.current = roundFactor;


  let activeCurrencies = activeCurrencyObjects.map(c => c.code);

  if (homeCurrency && activeCurrencies.includes(homeCurrency)) {
    activeCurrencies = [
      homeCurrency,
      ...activeCurrencies.filter(c => c !== homeCurrency),
    ];
  }

  if (!cashDrawerSelected) {
    setCurrencyRows(activeCurrencies);
  }
}

    setLastCurrencyFetchDate(currentDate);

  } catch (error) {
    console.error("Failed to fetch currency data:", error);
  }
}, [state.operatingDate, lastCurrencyFetchDate]);



const fetchCashDrawersList = useCallback(async () => {
  if(state && state.cashDrawerListMaster.length) return;
  try {
    const res = await APIEndpoint.get("cashRegister/cashDrawers");
    const list =
      res?.result?.map((drawer, index) => ({
        key: index,
        label: drawer.value,
        value: drawer.id,
        locationCode:drawer.locationCode
      })) || [];


   setState((prev) => ({ ...prev, cashDrawerListMaster: list }));
  } catch (error) {
    console.error("Failed to fetch cash drawers:", error);
  }
}, []);


  const fetchSalesSummary = useCallback(
    async (data) => {
      const { flightNumber, origin, destination, std } = data || {};
  
      if (!flightNumber) return;
      setCatererLoading((_)=>({..._,caterer:false,passenger:true}));
      try {
        const res = await APIEndpoint.post("operations/manifests", {
          sectors: [
            {
              flightNumber,
              origin,
              destination,
              flightDate: moment(
                formatDateByTimezone(new Date(std), false)
              ).format("YYYY-MM-DD"),
            },
          ],
        });
        if (res?.manifests?.length) {

setPassengersList(prev => {
  const manifest = res?.manifests?.[0];
  if (!manifest) return prev;

  const manifestKey = manifest.key;

  const newPasngrs = manifest.passengers
    .filter(psr => psr.seatNo !== null)
    .map(m => ({
      key: m.passengerId,
      label: `${m.name} (${m.seatNo} - ${m.pnr})`,
      value: m.passengerId,
    }));

  const combinedPassengers = [
    ...(prev?.passengers || []),
    ...manifest.passengers
  ];


  const uniquePassengers = Array.from(
    new Map(combinedPassengers.map(p => [p.passengerId, p])).values()
  );

  return {
    manifestsByKey: {
      ...(prev?.manifestsByKey || {}),
      [manifestKey]: manifest
    },
    passengers: uniquePassengers,
    pasngrs: newPasngrs
  };
});


      setCatererLoading((_)=>({..._,caterer:false,passenger:false}));


        }
      } catch (err) {
      setCatererLoading((_)=>({..._,caterer:false,passenger:false}));


        console.error("Sales summary fetch failed", err);
      }
    },
    [cateringGroupSelected,mode.edit]
  );

const fetchRotationSalesSummary = useCallback(
  async (id) => {

    if (!id || rotationLoadingRef.current || state.userSelected) return;
    rotationLoadingRef.current = true;
    try {
    const res = await APIEndpoint.post(`operations/rotations/${id}/sales`);
      if (res) {
        const cardAmount = resolveAmount(res.card);
        const cashAmount = resolveAmount(res.cash);

    setCardSalesFromPOS( Number(cardAmount) === 0 ? 0 :  Number(cardAmount));
    setTotalSalesFromPOS( Number(cashAmount) === 0 ? 0 :  Number(cashAmount));
    setCrewSales(res?.crewSales || []);
      }
    } catch (err) {
      console.error("Rotation sales summary fetch failed", err);
    } finally {
      rotationLoadingRef.current = false;
    }
  },
  [state.userSelected,cateringGroupSelected]
);

const fetchCashDeposits = useCallback(async () => {

  if (fetchCashDeposits.loading) return;
  if(!cashDrawerSelected) return;
  fetchCashDeposits.loading = true;
  setLoadingCashDeposits(true);
  gridRef.current?.api?.showLoadingOverlay();
  try {
    let totalCount = depositTotalCount;
    let firstRes = null;

    if (!totalCount || totalCount === null || totalCount === undefined) {
      firstRes = await APIEndpoint.post("cashRegister/v2/deposits/find", {
        cashDrawerId: cashDrawerSelected?.value ?? null,
        targetDate: formatDateByTimezone(
          state.operatingDate ? new Date(state.operatingDate) : new Date(),
          false
        ),
        employeeId: null,
        employeeCode: null,
        cateringRotationId: cateringGroupSelected?.value ?? null,
        page: 1,
        limit: 1,
      });

      totalCount = firstRes?.count ?? 0;
      setDepositTotalCount(totalCount);
    }

    if (totalCount === 0) {
      gridRef.current?.api?.showNoRowsOverlay();
      setListingItems({ count: 0, items: [] });
      return;
    }

    let data = null;

    if (totalCount === 1) {
      if (!firstRes) {
        firstRes = await APIEndpoint.post("cashRegister/v2/deposits/find", {
          cashDrawerId: cashDrawerSelected?.value ?? null,
          targetDate: formatDateByTimezone(
            state.operatingDate ? new Date(state.operatingDate) : new Date(),
            false
          ),
          employeeId: null,
          employeeCode: null,
          cateringRotationId: cateringGroupSelected?.value ?? null,
          page: 1,
          limit: 1,
        });
      }

      data = firstRes;
    }

    if (totalCount > 1) {
      data = await APIEndpoint.post("cashRegister/v2/deposits/find", {
        cashDrawerId: cashDrawerSelected?.value ?? null,
        targetDate: formatDateByTimezone(
          state.operatingDate ? new Date(state.operatingDate) : new Date(),
          false
        ),
        employeeId: null,
        employeeCode: null,
        cateringRotationId: cateringGroupSelected?.value ?? null,
        page: 1,
        limit: totalCount,
      });
    }

    if (data?.items?.length > 0) {
      gridRef.current?.api?.hideOverlay();
    } else {
      gridRef.current?.api?.showNoRowsOverlay();
    }

    setListingItems({
      count: data.count || 0,
      items: data.items || [],
    });

  } catch (err) {
    console.error("Cash deposits fetch failed", err);
    gridRef.current?.api?.showNoRowsOverlay();
  } finally {
    setLoadingCashDeposits(false);
    fetchCashDeposits.loading = false;
  }
}, [
  cashDrawerSelected?.value,
  state.operatingDate,
  cateringGroupSelected?.value,
]);

const validatePassengerRow = (index, passengerRow) => {
  const errors = {};

  if (!passengerRow.sector) errors.sector = "Sector is required";
  if (!passengerRow.passenger) errors.passenger = "Passenger is required";
  if (passengerRow.amount === "" || passengerRow.amount === null || passengerRow.amount === undefined) {
    errors.amount = "Amount is required";
  }

  setPassengerErrors(prev => {
    const updated = [...prev];
    updated[index] = errors;
    return updated;
  });
};

const fetchDepositSectors = useCallback(async () => {

  if (fetchDepositSectors.inFlight) return;
  fetchDepositSectors.inFlight = true;

  try {
    setCatererLoading((_) => ({ ..._, caterer: true, passenger: false }));

    const body1 = {
      date: formatDateByTimezone(
        state.operatingDate ? new Date(state.operatingDate) : new Date(),
        false
      ),
      employeeCode: state.userSelected?.value ?? null,
    };

    const reqKey = `${body1.date}_${body1.employeeCode || "ALL"}`;

    if (fetchDepositSectors.lastKey === reqKey) {
      setCatererLoading((_) => ({ ..._, caterer: false, passenger: false }));
      fetchDepositSectors.inFlight = false;
      return;
    }

    fetchDepositSectors.lastKey = reqKey;

    const [resRotation] = await Promise.all([
      APIEndpoint.post("operations/rotations/find", body1),
    ]);

    if (resRotation?.rotations?.length) {
      const sectorsLookUp = new Map(
        resRotation.rotations.map((it) => [it.id, it.legs])
      );

      const list =
        resRotation.rotations.map((rot, index) => {
          const dte = moment(rot.legs[0]?.std)
            .tz(getCultureFromLs()?.timezone.name)
            .format("DD-MM-YYYY hh:mm A");
         
          return {
            key: index,
            label: `${rot.tailNumber}/${rot.flightPath}/${dte}`,
            value: rot.id,
          };
        }) || [];

      setCateringGroupsList(list);
      setSectors(sectorsLookUp);
let maxWidth = 0;
list?.forEach(item => {
  const w = calculateTextWidth(item.label);
  if (w > maxWidth) maxWidth = w;
});

setCateringGroupWidth(prev => {
     const nextWidthPx = Math.max(maxWidth + SAFE_PADDING, MIN_CATGROUP_WIDTH);
  const nextWidth = `${nextWidthPx}px`;
  if (prev.catgroupWidth === nextWidth) return prev; 
  return { ...prev, catgroupWidth: nextWidth };

});
    } else {
      setCateringGroupsList([]);
      setSectorSelected(null);
    }
  } catch (error) {
    console.error("Failed to fetch rotations:", error);
  } finally {
    setCatererLoading((_) => ({ ..._, caterer: false, passenger: false }));
    fetchDepositSectors.inFlight = false; 
  }
}, [state.userSelected, state.operatingDate]);


const getRate = useCallback((from, to) => {
  if (from === to) return 1;
  return exchangeRates.get(`${from}_${to}`) ?? 1;
}, [exchangeRates]);

const handleCashSaleChange = (currency, value) => {
  const homeCurrency = getCultureFromLs().currency.code;
  const rate = getRate(currency, homeCurrency);

    setCashSales(prev => {
    const next = {
      ...prev,
      [currency]: value
    };

    if (currency !== "crewRefund") {
      next.crewDeposits = {
        ...prev.crewDeposits,
        [currency]: parseFloat(rate * value) || 0
      };
    }

    return next;
  });


};


const onDateChange=(e)=>{
  if(!mode.edit){
    resetDepositContext();
  }
    setState( (_prev) => {
        return { ..._prev,operatingDate:e.target.value}
      });
}
  const addPassenger = () => {
    setPassengers([...passengers, { sector: null, passenger: null, amount: '' }]);
  };


const updatePassenger = async (index, field, value, passengerFind = false,editMode = false) => {
  if ((field === 'passenger' || field === 'sector') && !editMode) {

    const newSector = field === 'sector' ? value : passengers[index].sector;
    const newPassenger = field === 'passenger' ? value : passengers[index].passenger;

    if (newSector && newPassenger) {
      const isDuplicate = passengers.some((p, idx) => (
        idx !== index &&
        p.sector?.value === newSector.value &&
        p.passenger?.value === newPassenger.value
      ));

      if (isDuplicate) {
        setMessage({error:"A payment already exists for this passenger and sector."});
        return;
      }
    }
  }
setPassengers((prev) => {
    const updatedPassengers = [...prev];
    updatedPassengers[index] = {
      ...updatedPassengers[index],
      [field]: value,
    };
    if (field === 'amount') {
      const totalPassengerDeposit = updatedPassengers.reduce((sum, p) => {
         const amt = round2(roundByFactor(p.amount)) || 0;
        return sum + amt;
      }, 0);

      setCashSales((prevSales) => ({
        ...prevSales,
        passengerDeposit: totalPassengerDeposit,
      }));
    }
    if (!editMode) {
  validatePassengerRow(index, updatedPassengers[index]);
}

  return updatedPassengers;
});

  if (value && passengerFind && sectorsListRef.current && sectorsListRef.current.length) {
    const sectorDet = sectorsListRef.current.find((st) => st.id === value.value);
   
    if (sectorDet) {
      await fetchSalesSummary(sectorDet);
    }
  }
};

const removePassenger = (index) => {
  const updated = passengers.filter((_, i) => i !== index);

  const finalList = updated.length === 0 
    ? [{ sector: null, passenger: null, amount: '' }]
    : updated;

  setPassengers(finalList);

  setPassengerErrors(prev => {
    const newErrors = prev.filter((_, i) => i !== index);

    if (finalList.length === 1 && updated.length === 0) {
      return [{}];
    }

    return newErrors;
  });

  const total = finalList.reduce((sum, p) => sum + (parseFloat(p.amount) || 0), 0);

  setCashSales(prev => ({
    ...prev,
    passengerDeposit: total
  }));
};

const hasErrors = useMemo(() => {
  return passengers.some((row, index) => {
    const err = passengerErrors[index] || {};

    const isRowCompletelyEmpty =
      !row?.sector &&
      !row?.passenger &&
      (row?.amount === "" || row?.amount === null || row?.amount === undefined);

    if (isRowCompletelyEmpty) return false;

    return (
      !!err.sector ||
      !!err.passenger ||
      !!err.amount
    );
  });
}, [passengers, passengerErrors]);

const disableSubmit = useMemo(() => {
  if (
    !state.userSelected ||
    (!editDeposit && mode.edit) ||
    !createDeposit ||
    (mode.edit && !mode.editEnable) ||
    hasErrors
  ) {
    return true;
  }
  return false;
}, [
  state.userSelected,
  editDeposit,
  mode.edit,
  createDeposit,
  mode.editEnable,
  hasErrors
]);



const difference = useMemo(() => {
  const raw = totalDepositByCrew.catGroupSum - totalSalesFromPOS;
    const refund = parseFloat(refundtoCrew.amount) || 0;
const passengerDeposit = parseFloat(cashSales.passengerDeposit) || 0;

  const num = parseFloat(raw);

  return parseFloat((num - (refund + passengerDeposit)));

}, [totalDepositByCrew.catGroupSum, refundtoCrew.amount, totalSalesFromPOS , cashSales.passengerDeposit]);

const differenceCrewSales = useMemo(() => {
  const raw = totalDepositByCrew.catGroup - totalSalesFromCrew;
  const num = Number(raw);
  return num === 0 ? 0 : num;
}, [totalDepositByCrew.catGroup, totalSalesFromCrew]);


const safeDifference = useMemo(() => {
  if (rotationLoadingRef.current) return 0;
  return difference;
}, [difference, rotationLoadingRef.current]);


const safeDifferenceCrew = useMemo(() => {
 if (rotationLoadingRef.current) return 0;
  return differenceCrewSales;
}, [differenceCrewSales, rotationLoadingRef.current]);

const cardDifferenceSales = useMemo(() => {
  const raw = cardSalesDeclaredTotal - cardSalesFromPOS;
  const num = Number(raw);
  return num === 0 ? 0 : num;
}, [cardSalesDeclaredTotal, cardSalesFromPOS]);

const cardDifferenceCrew = useMemo(() => {
  const raw = cardSalesDeclared - cardsalesFromCrew;
  const num = Number(raw);
  return num === 0 ? 0 : num;
}, [cardSalesDeclared, cardsalesFromCrew]);


const safeCardDifferenceSales = useMemo(() => {
  return rotationLoadingRef.current ? 0 : cardDifferenceSales;
}, [cardDifferenceSales, rotationLoadingRef.current]);


const safeCardDifferenceCrew = useMemo(() => {
  return rotationLoadingRef.current ? 0 : cardDifferenceCrew;
}, [cardDifferenceCrew, rotationLoadingRef.current]);



useEffect(() => {
  if (rotationLoadingRef.current) return;
  if (differenceCrewSales >= 0 && difference >= 0) {
    setShowRefundSection(true);
  }
}, [differenceCrewSales, difference]);


useEffect(() => {
  if (mode.edit && catererLoading.editLoading) return;

  if (mode.edit && refundInitialized) return;

  const base = Number((safeDifferenceCrew || 0));

  if (base > 0) {
      setRefundToCrew(prev => ({...prev,amount: round2(roundByFactor(base))}));
  } else {
    setRefundToCrew(prev => ({...prev,amount: ""}));
  }
  setRefundInitialized(true);
}, [safeDifferenceCrew, mode.edit]);

const differenceAfterRefundCrew = useMemo(() => {
  const base = parseFloat(safeDifferenceCrew) || 0;
  const refund = parseFloat(refundtoCrew.amount) || 0;
const passengerDeposit = parseFloat(cashSales.passengerDeposit) || 0;
  return parseFloat((base - (refund + passengerDeposit)));
}, [safeDifferenceCrew, refundtoCrew.amount, cashSales.passengerDeposit]);


const currencyListingProps = useMemo(() => ({
  currencyRows,
  cashSales,
  handleCashSaleChange
}), [currencyRows, cashSales, handleCashSaleChange]);

const handleUpdatedRemarks=(e,update)=>{
  e.preventDefault();
  setState((_)=>({..._,addComment:false,...update}))

}
const closeModal=()=>{
  setState((_)=>({..._,addComment:false}))
}

function enableButtons (submitBtnObj, cancelButtonObj, continueButtonObj) {
  submitBtnObj?.removeAttribute('disabled');
  if(cancelButtonObj){
  cancelButtonObj?.removeAttribute('disabled');
  }
  if(continueButtonObj){
  continueButtonObj?.removeAttribute('disabled');
  }
}

const saveUserDeposits = async (e,warningIgnored = false) => {
  setMessage({ text: "" });
  if (cashDrawerSelected && state.userSelected && cateringGroupSelected && sectorSelected) {

      if (!warningIgnored) {
      const diffCheck = Number(round2(roundByFactor((differenceAfterRefundCrew))));
      setState(_ => ({
        ..._,
        warningPop: diffCheck !== 0
      }));
      if(diffCheck !== 0){
      return;
      }
    }
      const continueButtonObj = document.getElementsByClassName('continue-button')[0];
        continueButtonObj?.setAttribute('disabled', 'true');

    let refundDetails = [];
    const sectorDet = sectorsList.find(st => st.id === sectorSelected.value);

    const { std,flightNumber, origin, destination } = sectorDet || {};

    if (!sectorDet) {
       return;
    }
if (passengersList?.passengers?.length > 0 && passengers?.length > 0) {

     refundDetails = passengers.map((psng,index) => {
   const sectorKey = psng?.sector?.label && psng?.sector?.flightArr ? `${psng.sector.label}/${psng.sector.flightArr}` : null;
const manifest = passengersList?.manifestsByKey?.[sectorKey];
    if (!manifest) return null;

    const {flightNumber,origin,destination,flightDate} = manifest;
      const passengerDet = passengersList.passengers.find(pngL => psng?.passenger?.value.toString() === pngL.passengerId?.toString());
      if (!passengerDet) return null; 

      const { status, pnr, name, title, passengerId, seatNo } = passengerDet;
      return {
        flightNumber,
        origin,
        destination,
        flightDate: formatDateByTimezone(flightDate, false),
        status,
        pnr,
        name,
        title:title??"",
        passengerId: passengerId.toString(),
        seatNo,
        currency: getCultureFromLs().currency.code,
        amount: Number(psng.amount) || 0,
      };
    })
    .filter(Boolean); 
}
       const submitBtnObj = document.getElementsByClassName('done-button')[0];
        const commentButtonObj = document.getElementsByClassName('uploadImage-button')[0];
        submitBtnObj?.setAttribute('disabled', 'true');
        commentButtonObj?.setAttribute('disabled', 'true');

    const body = {
      cashDrawerId: cashDrawerSelected.value,
     ...(!mode.edit ? {targetDate: formatDateByTimezone(state.operatingDate ? new Date(state.operatingDate) : new Date(), false)}:{}),
      ...(!mode.edit ? {employeeId: state.userSelected.key}:{}),
    ...(!mode.edit ?{ cateringRotationId: cateringGroupSelected?.value}:{}),
      sectors: [
        {
          flightNumber,
          origin,
          destination,
          flightDate: moment(formatDateByTimezone(new Date(std), false)).format('YYYY-MM-DD'),
        },
      ],

      items: (() => {
        const entries = Object.entries(cashSales);
        const filteredEntries = entries.filter(([key]) => key !== 'crewDeposits' && key !== 'passengerDeposit');
        const mappedItems = filteredEntries.map(([key, value]) => ({
          currencyCode: key,
          amount: parseFloat(value),
        }));
        const validItems = mappedItems.filter(item => !isNaN(item.amount));
        return validItems;
      })(),
     totalCashSales:!totalSalesFromPOS? 0: parseFloat(parseFloat(totalSalesFromPOS)),
    declaredCardSales:!cardSalesDeclared? 0: parseFloat(parseFloat(cardSalesDeclared)),
     totalCardSales: !cardSalesFromPOS? 0: parseFloat(parseFloat(cardSalesFromPOS)),
      refunds: refundDetails,
    remarks:state.comment??"",
  ...( refundtoCrew?.amount!==""? {crewRefunds: [{currencyCode: refundtoCrew.currencyCode.value, amount: Number(refundtoCrew.amount) }]}:{})
    };
    if(!body.items.length){
      setMessage({ error: `Must contain at least 1 crew currency deposit` });
          enableButtons(submitBtnObj,commentButtonObj,continueButtonObj);
            return;
    }
    if(!mode.edit && !body.employeeId){
      setMessage({ error: `Selected Crew Member Not Found` });
          enableButtons(submitBtnObj,commentButtonObj,continueButtonObj);
            return;
    }

    try {
  
      const res = !mode.edit? await APIEndpoint.post(`cashRegister/v2/deposits`, body):await APIEndpoint.put(`cashRegister/v2/deposits/${mode.editId}`, body);
      if (res?.message) {
        toast.success(res.message || "Success");
        if(!mode.edit){
          setCashSales({ crewDeposits: {}, passengerDeposit: 0 });
          skipCalcRef.current = true;
          setTotalDepositByCrew({ catGroup: 0, catGroupSum: 0 });
          lastTotalRef.current = 0;
          setPassengerErrors([]);
          setCashDrawerSelected(null);
          setCardSalesDeclared("");
          setCardSalesDeclaredTotal(0);
          prevDateRef.current = null;
          setPassengersList({});
          setPassengers([{ sector: null, passenger: null, amount: '' }]);
        }
        
        if(mode.edit && mode.editId){
           skipNextEditFetchRef.current = true;
          resetControls();
        }
         setState((_)=>({..._,comment:null,userSelected:null,warningPop: false})); 
      }
    } catch (error) {
       const errMsg = JSON.parse(error.message);
      setMessage({ error: errMsg?.data?.message || 'Failed to save deposits' });
      enableButtons(submitBtnObj,commentButtonObj,continueButtonObj);
         setState((_)=>({..._,warningPop: false})); 

    }
   } else {
    if((cashDrawerSelected && state.userSelected && cateringGroupSelected) && !sectorSelected){
    setMessage({ error: `No Sectors available for cash drawer ${cashDrawerSelected?.locationCode}`});
     lastTotalRef.current = 0;
    }else{
    const missingFields = [];
    if (!cashDrawerSelected) missingFields.push("Cash drawer");
    if (!state.userSelected) missingFields.push("Crew member");
    if (!cateringGroupSelected) missingFields.push("Catering group");
    setMessage({ error: `Missing required field${missingFields.length > 1 ? 's' : ''}: ${missingFields.join(', ')}` });
     lastTotalRef.current = 0;
    }

  }
};  

const onRowClicked = async (e) => {
skipCalcRef.current = true;
lastTotalRef.current = 0;
setTotalDepositByCrew({ catGroup: 0, catGroupSum: 0 });
  const { id, sessionId } = e.data || {};
  if (!id) return;
  if (sessionId && (activeSessionId!== sessionId) && state.editEnable) return;

  setRefundToCrew({
  currencyCode: {
    key: 1,
    label: state?.baseCurrency || getCultureFromLs()?.currency?.code,
    value: state?.baseCurrency || getCultureFromLs()?.currency?.code
  },
  amount: ""
});
  setSelectedRowIndex(e.rowIndex);
  lastTotalRef.current = 0;
  setPassengers([{ sector: null, passenger: null, amount: '' }]);
  setSectorSelected(null);
  setCashSales({ crewDeposits: {}, passengerDeposit: 0 });
  setPassengersList({});
  setPassengerErrors([]);
  setTotalSalesFromPOS(0);
  setTotalSalesFromCrew(0);
  setCardSalesDeclared("");
  setCardSalesDeclaredTotal(0);
  setCardSalesFromPOS(0);
  setCardSalesFromCrew(0);

setCatererLoading((_) => ({ ..._, caterer: false, passenger: false }));

  setCatererLoading((_)=>({..._,editLoading:true}));
  try {
    const res = await APIEndpoint.get(`cashRegister/v2/deposits/${id}`);
    const deposit = res?.cashDeposit;
    if (!deposit) return;
    const {
      id: depositId,
      cashDrawer,
      cateringRotation,
      crew,
      items = [],
      refunds = [],
      sectors = [],
      targetDate,
      totalCashSales,
      totalDeclaredCardSales,
      totalCardSales,
      totalCrewRefund,
      baseCurrency,
      remarks,
      crewRefunds= []
    } = deposit;


    setTotalSalesFromPOS(totalCashSales);
    setCardSalesFromPOS(totalCardSales);
    setCardSalesDeclared(totalDeclaredCardSales);
   setMode(prevState => ({...prevState,edit: true, editId: depositId}));
   userChangedDrawer.current = true;
   prevCrewDeclaredRef.current = totalDeclaredCardSales;
   if(crew){
  setState((prev) => ({
      ...prev,
      operatingDate: new Date(targetDate),
      userSelected: {
        key: crew.employeeId,
        label: `${crew.employeeCode} - ${crew.employeeName}`,
        value: crew.employeeCode,
      },
      baseCurrency:baseCurrency ?? getCultureFromLs().currency.code,
      comment:remarks??""
    }));
   }

     setCateringGroupSelected(cateringGroupList.find((ctr) => ctr.value === cateringRotation.id) || null);
  setCashDrawerSelected(state?.cashDrawerListMaster?.find((ctr) => ctr.value === cashDrawer.id) || null);

    if (items.length > 0) {
      setCashSales({ crewDeposits: {}, passengerDeposit: 0 }); 
      items.forEach((it) =>
        handleCashSaleChange(it.currencyCode, it.amount.toString())
      );
    }

let sectorOptions = sectorSelectOptionsList;
if ((!sectorOptions.length) && cateringRotation.id) {
  sectorOptions = await fetchSectors(cateringRotation.id,true); 
}
if (refunds?.length && sectorOptions?.length) {
  await new Promise((resolve) => {
    setPassengers((prev) => {
      const newPassengers = Array.from(
        { length: Math.max(prev.length, refunds.length) },
        (_, i) => prev[i] || { sector: null, passenger: null, amount: '' }
      );
      setTimeout(resolve, 0);
      return newPassengers;
    });
  });

  const sectorMap = new Map(sectorOptions.map((s) => [s.label, s]));

  for (const [index, rf] of refunds.entries()) {
    const { pnr, passengerId, seatNo, name, flightNumber, origin, destination, amount } = rf;
const sectSelOriginal = sectorMap.get(`${flightNumber}-${origin}-${destination}`);
const sectSel = sectSelOriginal ? { ...sectSelOriginal, flightArr: moment(formatDateByTimezone(rf.flightDate ? new Date(rf.flightDate) : new Date())).format("YYYY-MM-DD") } : null;
    if (sectSel) {
      await updatePassenger(index, 'sector', sectSel, true,true);
      await updatePassenger(index, 'passenger', {
        key: passengerId,
        label: `${name} (${seatNo} - ${pnr})`,
        value: passengerId,
      }, false,true);
      await updatePassenger(index, 'amount', amount.toString(), false,true);
    }
  }
}
if (crewRefunds?.length && currencyRows.length) {
  const rf = crewRefunds[0];

  const currencyOption = currencyRows
    ?.map((cr, index) => ({
      key: index + 1,
      label: cr,
      value: cr
    }))
    ?.find(c => c.value === rf.currencyCode);

  setRefundToCrew({currencyCode: currencyOption,amount: round2(roundByFactor(totalCrewRefund)) ?? ""});

  setRefundInitialized(true); 
}

    if (sectors?.length > 0) {
      const firstMatch = sectorOptions.find((st) =>sectors.some((rf) =>rf.destination === st.label.split("-")[2]));
      if (firstMatch) setSectorSelected(firstMatch);
    }
  } catch (err) {
    console.error('deposit fetch failed', err);
  }finally{
  setCatererLoading((_)=>({..._,editLoading:false}));
  }
};

async function resetControls() {
  setState((_)=>({..._,userSelected:null,addComment:false,comment:null})); 
    setTotalDepositByCrew({catGroup: 0, catGroupSum: 0});
  lastTotalRef.current = 0;
  prevDateRef.current = null;
  setPendingDepositCrewsList([]);
  setSelectedRowIndex(null);
  setPassengerErrors([]);
  setCashDrawerSelected(null);
  setTotalSalesFromPOS(0);
  setCardSalesFromPOS(0);
      setCrewSales([]);
    setSectorSelected(null);
    setPassengersList({});
    setSectorsList([]);
    setCardSalesDeclaredTotal(0);
    setSectorsSelectOptionsList([]);
    setPassengers([{ sector: null, passenger: null, amount: '' }]);
    setCrewMembers([]);
    setCardSalesDeclared("");
    setTotalSalesFromCrew(0);
    setCardSalesFromCrew(0);
          setCashSales({ crewDeposits: {}, passengerDeposit: 0 });
          setMode({edit:false,editId:null,editEnable:false});

}

useEffect(() => {
  if (mode.edit && cateringGroupSelected) {
    fetchRotationSalesSummary(cateringGroupSelected.value);
     fetchSectors(cateringGroupSelected?.value, true);
      if(mode.edit && prevDateRef && prevDateRef.current !== state.operatingDate){
        prevDateRef.current = state.operatingDate;
       fetchCurrencyEntity();
      fetchDepositSectors().catch((error) => {
        console.error('Error fetching deposit sectors:', error);
      });
    }
  }
}, [mode.edit,cateringGroupSelected,state.userSelected]);

const isEmptyObject = obj => {
  return Object.values(obj).every(value => value === null || value === "" || value === undefined);
};

const isSingleEmptyObject = arr => {
  return arr?.length === 1 && isEmptyObject(arr[0]);
};

const delPropRes={onCloseDelete:() => setState((_)=>({..._,warningPop:false})),onContinue:(e) =>  saveUserDeposits(e,true)};

  return (
    <div className="op-aircraft-container flexCol full-flex ag-theme-alpine-dark">

  {!(mode.edit && catererLoading.editLoading) ?<div className="crew-sales-container" style={{ overflowY:'auto',height:'calc(100vh - 215px)'}}>
      <div className="crew-sales-deposit">       
        <div className="form-row content-tabs justifyContentSpaceBetween custom-select-container stickyBackground" style={{position:'sticky',top:0}}>
          <div className='content-tabs form-row flexRow justifyContentFlexStart'>
          <div className="form-group">
             <div className='flexRow'>
              <label className={catererLoading.oprnDate?"":'reqm'}>Operating Date</label>
                {catererLoading.oprnDate ?<img src={LoadingGIF} className='' style={{width:'16px',height:'16px',marginLeft:'2px'}} alt="Loading" />:<></>}
               </div>
                    <button className="orderStatus-div">
                      <>
                      <NGODatePicker
                        style={{width: '8rem',border:'0.7px solid #fff',margin:0}}
                        value={state.operatingDate?new Date(state.operatingDate):new Date()}
                        dateFormat="dd/MM/yyyy"
                        name='operatingDate'
                        className='padding0'
                        maxDate={new Date()}
                        isclearable={!mode.edit}
                        isDisabled={mode.edit}
                        placeholder={'Operating Date'}
                        placeholdertext={'Operating Date'}
                        onChange={onDateChange} />
                            </>
                      </button>
          </div>
          <div className="form-group">
            {state && !state.crewMember ? (
            <div className="form-group">
           <div className='flexRow'>
            <label className='reqm'>Catering Group  </label>
          {catererLoading.caterer ?<img src={LoadingGIF} className='' style={{width:'16px',height:'16px'}} alt="Loading" />:<></>}
            </div>
           
          <CustomSelect
          options={cateringGroupList}
          placeHolder="Select Catering Group"
          width={cateringGroupWidth.catgroupWidth}
          isDisabled={catererLoading.caterer|| mode.edit}
          value={cateringGroupSelected}
          onChange={(val) => {
             if(!mode.edit){
              resetDepositContext();
      }
    setCateringGroupSelected(val);
    setCashDrawerSelected(null);
    userChangedDrawer.current = false;
    setDepositTotalCount(null);
    setListingItems({ count: 0, items: [] });
  }}

          />

          </div>):<></>}

          </div>

          <div className="form-group">
            {state ? (
            <div className="form-group">
         
            <label>Cash Drawer</label>
           
            <CustomSelect
            options={state?.cashDrawerList}
            placeHolder="Select Cash Drawer"
            width='16rem'
            isDisabled={mode.edit || !cateringGroupSelected}
            value={cashDrawerSelected}
            onChange={(val) => {
            userChangedDrawer.current = true;
              setCashDrawerSelected(val);
            if (!val) {
            setCrewMembers([]);
            setState(prev => ({ ...prev, userSelected: null }));
            }
            }}
            />
          </div>):<></>}

          </div> 
          <div className="form-group">
            {state && crewMembers && crewMembers.length ? (
            <div className="form-group">
            
            <label>Crew Member</label>
           
          <CustomSelect
          options={crewMembers}
          placeHolder="Select Crew Member"
          width={cateringGroupWidth.crewMemberWidth}
          isDisabled={loadingUser || mode.edit || !cashDrawerSelected || !cateringGroupSelected}
          value={state.userSelected}
          onChange={(val)=>setState((_)=>({..._,userSelected:val,filtersSelected:true}))}
          />
      
          </div>):<></>}

          </div>

          </div>

        </div>
   {viewCashDeposits ?   <div className="catering-groups-section">
   {!loadingCashDeposits && <div className='flexRow justifyContentSpaceBetween content-tabs'>
        <div className="flexRow alignItemsCenter section-header margTop0">
   <div className="alignItemsCenter flexRow se-scanner-la3">
    <span className='small-body-text-regular-label-upload'>
  Crew Members with Sales: <strong>{crewStats.crewWithSales}</strong>
    </span>
 </div>
  <div className="alignItemsCenter flexRow se-scanner-la3">
       <span className='small-body-text-regular-label-upload'>
 Crew Members who Deposited: <strong>{crewStats.totalDeposited}</strong>
       </span>
</div>
  <div className="alignItemsCenter flexRow se-scanner-la3" >
       <span className='small-body-text-regular-label-upload'>
 Crew Members with Pending Deposits: <strong>{crewStats.pending}</strong>
</span>

</div>

 {crewStats.pending > 0 && !mode.edit ?<div className={!crewStats?.pending?"alignItemsCenter flexRow se-scanner-la3":"alignItemsCenter flexRow dep-cap3"} onClick={capturePendingDeposits} style={{ position: "relative" }}>
       <span className='small-body-text-regular-label-upload' >
        {pendingPopupOpen ? <IoMdArrowDropup size={20} /> : <IoMdArrowDropdown size={20} /> }
       </span>
       {pendingPopupOpen && (
  <div className="pending-dropdown-capture">
    <div className="dropdown-content-capture alignItemsCenter">

      <div className="dropdown-list-capture sm-scrollbar">
        {pendingDepositCrewsList.length === 0 ? (
          <div className="dropdown-item-capture no-data-capture">No pending crew</div>
        ) : (
pendingDepositCrewsList.map((item, idx) => {
  const { crew } = item;

  return (
    <div
      key={crew?.employeeId || idx}
      className="dropdown-item-capture"
      onClick={(e) => {
           e.stopPropagation();
        const selectedCrew = crewMembers?.find(
          member => member.key === crew?.employeeId
        );

        if (selectedCrew) {
          setState(prev => ({
            ...prev,
            userSelected: selectedCrew
          }));
        }

        setPendingPopupOpen(false);
      }}
    >
      {crew?.employeeCode} - {crew?.employeeName}
    </div>
  );
})


        )}
      </div>

    </div>
  </div>
)}
</div>:null}

   </div>
           <div className='flexRow justifyContentFlexEnd margBtm16'>
             {mode.edit ?
  <button
    onClick={exitViewOnly}
  >
    <img src={closeIcon} title={mode.editEnable ? 'Exit Edit' : 'Exit View'} alt="close" data-icon="close" />
  </button>
: null}
</div>
      </div>}
   <div className="table-header"></div>
    <div id='myGrid'className="ag-theme-alpine-dark no-wrap" style={{height: `${gridHeight}px`}}>
      <AgGridReact
        id="ngo-grid"
        ref={gridRef}
        rowSelection="multiple"
        suppressCellFocus={true}
        overlayLoadingTemplate={
        '<span class="ag-overlay-loading-center">Please wait, data is fetching...</span>'
        }
        overlayNoRowsTemplate={
        '<span class="ag-overlay-no-rows-center">No Data </span>'
        }
        className="ngo-grid ag-theme-alpine-dark no-wrap"
        getRowStyle={() => ({ cursor: 'pointer'})}
        getRowClass={(params) => {
        const classes = [];
        if (params.node.rowIndex % 2 === 0) {
        classes.push("tableEvenRowClass");
        }
        if (params.node.rowIndex === selectedRowIndex) {
        classes.push("selectedRowClass");
        }

        return classes.join(" ");
        }}
        onGridReady={(params) => {
        if (!listingItems?.items?.length) {
        params.api.showNoRowsOverlay();
        }
        }}
        rowData={listingItems.items || []}
        columnDefs={columns}
        onRowClicked={onRowClicked} 
      />
    </div>

      </div>:null}
   
{viewCashDeposits?<CurrencyListing currencyListingProps={currencyListingProps}/>:null}

      </div>
 <div className="card-sales-section">
        <div className="card-totals">
          <div className="total-box">
            <label>Total Card Sales ({getSafeCurrencyCode()})</label>
            <div className="total-value">
            <FaRegCreditCard />
              <span>{round2(roundByFactor(cardSalesFromPOS))}</span>

            </div>
          </div>

       
          <div className="total-box">
            <label>Total Card Sales Declared ({getSafeCurrencyCode()})</label>
            <div className="total-value">
              <IoMdCard/>
              <input
                type="number"
                step="1"
                min='0'
                disabled={true}
                value={round2(roundByFactor(cardSalesDeclaredTotal))}
                onChange={(e) => setCardSalesDeclaredTotal(parseFloat(e.target.value)||"")}
                placeholder="0"
              />
            </div>
          </div>


          <div  className={`total-box ${round2(roundByFactor(safeCardDifferenceSales)) > 0  ? 'alt-up' : round2(roundByFactor(safeCardDifferenceSales)) < 0 ? 'alt-down' : ''}`}>
            <label>Difference (Catering Group)</label>
            <div className="total-value">
            {round2(roundByFactor(safeCardDifferenceSales)) > 0 ? (<IoIosTrendingUp style={{ color: '#00ff37' }} />) : round2(roundByFactor(safeCardDifferenceSales)) < 0 ? (<IoIosTrendingDown style={{ color: '#f71d00' }}/> ) : null}
              <span>{round2(roundByFactor(safeCardDifferenceSales))}</span>
            </div>
          </div>

      {/* card sales crew======================== */}

    
          <div className="total-box">
            <label>Total Card Sales by Crew ({getSafeCurrencyCode()})</label>
            <div className="total-value">
            <FaCreditCard />
              <span>{round2(roundByFactor(cardsalesFromCrew))}</span>

            </div>
          </div>

           <div className="total-box">
            <label>Total Card Sales Declared by Crew ({getSafeCurrencyCode()})</label>
            <div className="total-value">
              <IoCardOutline/>
              <input
              type="text"
              inputMode="decimal"
              value={cardSalesDeclared}
                onChange={(e) => {
              const raw = e.target.value;

              if (raw === "") {
              setCardSalesDeclared("");
              setCardSalesDeclaredTotal(prevCardDeclaredRef.current - prevCrewDeclaredRef.current);
              return;
              }

              if (/^\d*\.?\d*$/.test(raw)) {
              const num = parseFloat(raw) || 0;
              setCardSalesDeclared(raw);
              setCardSalesDeclaredTotal(prevCardDeclaredRef.current - prevCrewDeclaredRef.current + num);
              }
              }}
              placeholder="0.00"
              />
            </div>
          </div>

          <div  className={`total-box ${round2(roundByFactor(safeCardDifferenceCrew)) > 0  ? 'alt-up' : round2(roundByFactor(safeCardDifferenceCrew)) < 0 ? 'alt-down' : ''}`}>
            <label>Difference (Crew)</label>
            <div className="total-value">
            {round2(roundByFactor(safeCardDifferenceCrew)) > 0 ? (<IoIosTrendingUp style={{ color: '#00ff37' }} />) : round2(roundByFactor(safeCardDifferenceCrew)) < 0 ? (<IoIosTrendingDown style={{ color: '#f71d00' }}/> ) : null}
              <span>{round2(roundByFactor(safeCardDifferenceCrew))}</span>
            </div>
          </div>
  

      </div>

        </div>


            { <div className="totals-section">
{/* total sales of groups */}

          <div className="total-box">
            <label>Total Sales ({getSafeCurrencyCode()})</label>
            <div className="total-value">
              <PiMoneyFill/>
              <span>{round2(roundByFactor(totalSalesFromPOS))}</span>
            </div>
          </div>
              
      <div className="total-box">
            <label>Total Deposit ({getSafeCurrencyCode()})</label>
            <div className="total-value">
              <LiaMoneyBillWaveAltSolid />
               <span>{round2(roundByFactor(totalDepositByCrew.catGroupSum))}</span>
            </div>
          </div>

          <div className={`total-box ${round2(roundByFactor(safeDifference)) > 0  ? 'alt-up' : round2(roundByFactor(safeDifference)) < 0 ? 'alt-down' : ''}`}>
  <label>Difference (Catering Group)</label>

  <div className="total-value">
    {round2(roundByFactor(safeDifference)) > 0 ? (<IoIosTrendingUp style={{ color: '#00ff37' }} />) : round2(roundByFactor(safeDifference)) < 0 ? (<IoIosTrendingDown style={{ color: '#f71d00' }}/> ) : null}
    <span>{round2(roundByFactor(safeDifference))}</span>
  </div>
</div>


{/* ============================= */}
          <div className="total-box">
            <label>Total Sales by Crew ({getSafeCurrencyCode()})</label>
            <div className="total-value">
              <IoCashOutline/>
              <span>{round2(roundByFactor(totalSalesFromCrew))}</span>
            </div>
          </div>
              
      <div className="total-box">
            <label>Total Deposit by Crew ({getSafeCurrencyCode()})</label>
            <div className="total-value">
              <FaMoneyBillWave />
               <span>{round2(roundByFactor(totalDepositByCrew.catGroup))}</span>
            </div>
          </div>


<div className={`total-box ${round2(roundByFactor(differenceAfterRefundCrew)) > 0 ? 'alt-up' :round2(roundByFactor(differenceAfterRefundCrew)) < 0 ? 'alt-down' : ''}`}>
  <label>Difference (Crew)</label>
  <div className="total-value">{round2(roundByFactor(differenceAfterRefundCrew)) > 0 ? (
      <IoTrendingUpOutline style={{ color: '#00ff37' }} />
    ) : round2(roundByFactor(differenceAfterRefundCrew)) < 0 ? (
      <IoTrendingDownOutline style={{ color: '#f71d00' }} />
    ) : null}

    <span>{round2(roundByFactor(differenceAfterRefundCrew))}</span>
  </div>
</div>


        </div>
        }
{currencyRows.length ? <div className="passengers-section">
        <span className='large-button-text-medium'>Amount Returned to the Crew</span>
       
          <div  className="crew-row-refund margTop16">
            <div className="form-group">
              <label className='reqm'>Currency Code</label>
               <div className="margTop7"></div>
         <CustomSelect
          options={currencyRows?.map((cr,index)=>({key:index+1,label:cr,value:cr}))}
          placeHolder="Select Currency Code"
          isDisabled={!editRefund}
           value={currencyRows?.map((cr,index)=>({key:index+1,label:cr,value:cr}))?.find(cr=>cr.value === refundtoCrew.currencyCode?.value)}
           onChange={(val)=>setRefundToCrew((prev)=>({...prev, currencyCode: val }))}
          />
            </div>

            <div className="flexRow form-group">
              <label className='reqm'>Amount ({getSafeCurrencyCode()})</label>
              <div className="amount-input-wrapper">
                <input
                type="text"
                inputMode="decimal"
                className="edit-input-passenger-mant"
                disabled={!editRefund}
                value={refundtoCrew.amount}
                  onFocus={() => {
    setRefundToCrew(prev => {
      if (typeof prev.amount === "string" && prev.amount.endsWith(".00")) {
        return { ...prev, amount: prev.amount.replace(/\.00$/, "") };
      }
      return prev;
    });
  }}

                onChange={(e) => {
                const raw = e.target.value;

                if (raw === "") {
                setRefundToCrew(prev => ({ ...prev, amount: "" }));
             
                return;
                }

                if (/^\d*\.?\d*$/.test(raw)) {
                setRefundToCrew(prev => ({ ...prev, amount: raw }));
           
                }
                }}
                placeholder="0.00"
                />
              </div>
        </div>
          </div>
      
      </div>:null}
   
     {viewRefunds && (showRefundSection || hasRefunds) ? <div className="passengers-section">
        <span className='large-button-text-medium'>Amount Paid Back to Passenger</span>
        
        {passengers?.map((passenger, index) => (
          <div key={index} className="passenger-row margTop16">
            <div className="form-group">
              <label className='reqm'>Sector</label>
               <div className="margTop7"></div>
         <CustomSelect
          options={sectorSelectOptionsList}
          placeHolder="Select Sectors"
          autoWidth={true}
          isDisabled={!editRefund}
          value={passenger.sector}
          onChange={(val)=>updatePassenger(index, 'sector', val,true)}
          />
          {passengerErrors[index]?.sector && (
  <div className="subheading-text-medium-title text-danger">{passengerErrors[index].sector}</div>
)}
            </div>

            <div className="form-group">
              <div className='flexRow'>
            <label className='reqm'>Passenger</label>
          {catererLoading.passenger?<img src={LoadingGIF} className='' style={{width:'16px',height:'16px'}} alt="Loading" />:<></>}
            </div>
               <div className="margTop7"></div>
         <CustomSelect
          options={passengersList?.pasngrs}
          placeHolder="Select Passenger"
          autoWidth={true}
          value={passenger.passenger}
          isDisabled={catererLoading.passenger || !editRefund}
          onChange={(val)=>updatePassenger(index, 'passenger', val,false)}
          />
                    {passengerErrors[index]?.passenger && (
  <div className="subheading-text-medium-title text-danger">{passengerErrors[index].passenger}</div>
)}
            </div>

            <div className="flexRow form-group">
              <label className='reqm'>Amount ({getSafeCurrencyCode()})</label>
              <div className="amount-input-wrapper">
                <input
                  type="text"
                  inputMode="decimal"
                  className='edit-input-passenger-mant'
                  value={passenger.amount}
                  disabled={!editRefund}
                  onChange={(e) => updatePassenger(index, 'amount', sanitizeNumberInput(e.target.value),false)}
                  placeholder="0.00"
                />

    
            {deleteRefunds? <button 
                  title='Delete Passenger'
                  className="delete-btn"
                  disabled={isSingleEmptyObject(passengers)}
                   onClick={() => removePassenger(index)}
                >
                <img className='aircraft-actions' alt='delete'   src={deleteIcon}/>
                  
                </button>:null}
              </div>
    {passengerErrors[index]?.amount && (
  <div className="subheading-text-medium-title text-danger">{passengerErrors[index].amount}</div>
)} 
        </div>
          </div>
        ))}

       {createRefund? <button
          className="uploadImage-button add-passenger-btn"
          onClick={addPassenger}
          disabled={false}
        >
          <div className='flexRow justifyContentCenter alignItemscenter'><span className="small-button-text-regular">+&nbsp;Passenger</span></div>
        </button>:null}
      </div>:null}

      <div className='flexRow justifyContentCenter alignItemsCenter'>
       {createDeposit || editDeposit ?<> 
        <button className="uploadImage-button" disabled={!state.userSelected || (!editDeposit && mode.edit) || !createDeposit ||(mode.edit && !mode.editEnable) } onClick={()=>setState((prev)=>({...prev,addComment:true}))}>
           + Comment
        </button>
       <button className="done-button margRight15" onClick={(e)=>saveUserDeposits(e,false)} disabled={disableSubmit}>
          Submit Deposit
        </button>
       

        </>
        
        :null}
      </div>



    </div>:<LoaderPop/> }
      <ToastContainer  position="top-center"  
  hideProgressBar={true}
   toastStyle={{ fontSize: '1rem' }} 
  newestOnTop={true}
  rtl={false}
  pauseOnFocusLoss={false}
  draggable={false}
  pauseOnHover ={false}
  />

      {
       state && state.addComment ?
        <EditModal
          isSubModal
          customModalStyle={{height:'40vh',overflowY:'hidden'}}
          showFieldsInColumn
          title={'Add Comment'}
          fields={
            RemarkFormFields.map((_) => ({ ..._, initialValue: state.comment || '' }))
          }
          onSubmit={handleUpdatedRemarks}
          onClose={closeModal}>
        </EditModal>
     :null }
     {
     !ready &&<div className='overlay_hide sub'></div>
      }
           {state && state.warningPop && <DeleteConf  {...delPropRes} description={`The amount returned to the crew is ${differenceAfterRefundCrew < 0 ?'more':'less'}  by ${Math.abs(round2(roundByFactor(differenceAfterRefundCrew)))} ${refundtoCrew.currencyCode.value}. Do you want to continue?`} />}
    </div>
  );
};

